module.exports = {
  "country": "DK",
  "artist": "Grethe & Jørgen Ingmann",
  "song": "Dansevise",
  "year": "1963",
  "place": "1",
  "spotify": "3KHCdrqONvtp33NFO7BVv6"
};